/**
 * VitaHuma — Shared Scroll Animation System
 * Uses IntersectionObserver to add .vh-visible to [data-vh-anim] elements
 * Safe to include in multiple sections — initializes only once.
 */
(function () {
  'use strict';

  function initVhAnimations() {
    if (window._vhAnimReady) return;
    window._vhAnimReady = true;

    // Graceful degradation — no IntersectionObserver support
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-vh-anim]').forEach(function (el) {
        el.classList.add('vh-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vh-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -56px 0px',
      }
    );

    document.querySelectorAll('[data-vh-anim]').forEach(function (el) {
      observer.observe(el);
    });

    // ── Counter animation ─────────────────────────────────────
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('[data-vh-counter]').forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    var target = parseFloat(el.dataset.vhCounter) || 0;
    var duration = parseInt(el.dataset.vhCounterDuration) || 1600;
    var suffix = el.dataset.vhCounterSuffix || '';
    var prefix = el.dataset.vhCounterPrefix || '';
    var decimals = (target % 1 !== 0) ? 1 : 0;
    var start = null;
    var startVal = 0;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = startVal + (target - startVal) * eased;
      el.textContent = prefix + current.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  // ── Init ────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVhAnimations);
  } else {
    initVhAnimations();
  }

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function () {
    window._vhAnimReady = false;
    initVhAnimations();
  });
})();
